<template>
    <div class="body-2">
        <p class="pb-0 mb-0">
            <span v-if="supervisors[0]">Supervisors :</span>
            <span v-for="(item, index) in supervisors" :key="index"
            :class="{'indigo--text text--darken-2':item.category_id}">
                <span v-html="item.first_name"></span> <span v-html="item.last_name"></span>
                <span v-if="index <   supervisors.length - 1">,</span>
            </span>
        </p>
        <div  v-if="object_type" >
            <p v-if="object_type.start_year" class="py-0 my-0">Starting year: {{ object_type.start_year }} </p>
            <p v-if="object_type.defense_date < '2100-01-01'" class="py-0 my-0">
                <span class="font-weight-bold"> Defense:</span>
                {{object_type.defense_date| dateEU('DD.MM.YYYY')}}<span v-if="object_type.defense_place">,&nbsp;&nbsp;{{object_type.defense_place}}</span>
            </p>
            <p v-else class="py-0 my-0">
                Defense not available.
            </p>
            <p v-if="object_type.url" class=" mx-0 px-0 pt-0 mt-1 mb-0">
                <a class="indigo--text text--darken-2 text-body-2 font-weight-bold"  :href="object_type.url" target="_blanc">
                    <img  class="pl-0 pb-0"  v-if="!mobile" src="../../../../assets/research/acrobat_icon.png" >
                    <span v-else class="text-body-2 purple--text text--purple-4 pl-0 pb-0">Download PDF</span>
                </a>
            </p>
        </div>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
  props:['supervisors','object_type'],
  computed: {
    ...mapGetters('header',{
        mobile:'mobile',
    })
  },
}
</script>
